export default __webpack_public_path__ + "static/media/profile.16b74247.png";